const LoadingCad = () => {
  return (
    <div className="tw-p-5 tw-h-40 tw-bg-white tw-shadow-lg hover:tw-shadow-xl tw-mb-3 tw-basis-64 tw-w-64 tw-box-content tw-cursor-pointer hover:tw-scale-105 tw-transition-transform tw-flex-1 tw-max-w-xl"></div>
  );
};

export default LoadingCad;
